<template>
    <div class="navbar navbar-inverse navbar-fixed-top opaque-navbar">
        <div class="container">
            <div class="collapse navbar-collapse" id="navMain">
                <ul class="nav navbar-nav pull-right">
                    <li>
                        <router-link to="/">Home</router-link>
                    </li>
                    <li>
                        <router-link to="/browse">Browse</router-link>
                    </li>
                    <li>
                        <router-link to="/games">Games</router-link>
                    </li>
                    <li v-if="sharedState.loggedIn">
                        <strong>Welcome, {{ sharedState.username }}</strong>
                    </li>
                    <li v-if="sharedState.loggedIn">
                        <a href="/" @click.prevent="logout">Logout</a>
                    </li>
                    <li v-else>
                        <router-link to="/login">Login</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { store } from '../framework/store'
export default {
    methods: {
        logout() {
            store.clear();
            this.$router.push('/');
        }
    },
}
</script>

<style scoped>
    .opaque-navbar {
        background-color: rgba(0,0,0,0.5);
        /* Transparent = rgba(0,0,0,0) / Translucent = (0,0,0,0.5)  */
        height: 50px;
        border-bottom: 0px;
        transition: background-color .5s ease 0s;
        position: absolute;
    }
    
    .opaque-navbar.opaque {
        background-color: black;
        height: 50px;
        transition: background-color .5s ease 0s;
    }

    .opaque-navbar navbar-header > img { top: 110px; }
</style>


// WEBPACK FOOTER //
// src/components/Navbar.vue